import React, { useCallback, useState } from "react";
import styled from "styled-components";
import {
  BASIC_DARK_GRAY,
  BASIC_LINE,
  BASIC_WHITE,
  BASIC_YELLOW,
} from "../../constants/colors";

type Props = {
  text: string;
  content: string;
};

export const Collapse: React.FC<Props> = ({ text, content }) => {
  const [isExpand, setIsExpand] = useState(false);

  const handleToggleExpand = useCallback(() => {
    setIsExpand((prev) => !prev);
  }, []);

  return (
    <CollapseContainer onClick={handleToggleExpand}>
      <ContentContainer>
        <CollapsibleButton $isExpanded={isExpand}>
          <Question>Q</Question>
          <Content2>{text}</Content2>
        </CollapsibleButton>

        <Content $isVisible={isExpand}>{content}</Content>
      </ContentContainer>

      <TriangleIcon $isVisible={isExpand} />
    </CollapseContainer>
  );
};

const CollapseContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: start;
  margin: 0 0 17px 0;
  padding: 2px 0 0 0;
  border-bottom: 1px solid ${BASIC_LINE};
`;

const ContentContainer = styled.div`
  width: 100%;
`;

const CollapsibleButton = styled.button<{ $isExpanded: boolean }>`
  background-color: transparent;
  cursor: pointer;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 14px;
  padding: 0;
  color: ${BASIC_DARK_GRAY};
  font-weight: 600;
  line-height: 1.6em;
  display: flex;
  align-items: flex-start;
  span:first-child {
    flex-shrink: 0;
  }
  div {
    flex: 1;
    word-break: break-word;
  }
`;

const Content = styled.div<{ $isVisible: boolean }>`
  overflow: hidden;
  font-family: "Hiragino Sans";
  font-size: 14px;
  font-weight: 300;
  margin: ${({ $isVisible }) => ($isVisible ? "0 15px 0 0" : "0")};
  padding: ${({ $isVisible }) => ($isVisible ? "0 0 15px 40px" : "0")};
  white-space: pre-line;
  line-height: 1.6em;
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
  height: ${({ $isVisible }) => ($isVisible ? "auto" : 0)};
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
`;

const Content2 = styled.div`
  font-family: "Hiragino Sans";
`;

const TriangleIcon = styled.span<{ $isVisible: boolean }>`
  border-right: 7px solid transparent;
  border-bottom: 5px solid ${BASIC_DARK_GRAY};
  border-left: 7px solid transparent;
  margin: 6px;
  transform: ${({ $isVisible }) =>
    $isVisible ? "rotate(0deg)" : "rotate(180deg)"};
`;

const Question = styled.span`
  color: ${BASIC_WHITE};
  font-weight: 600;
  line-height: 1em;
  padding: 4px 6px 4px 6px;
  border-radius: 4px;
  margin: 0 15px 15px 0;
  font-size: 16px;
  left: 0;
  top: 0;
  font-family: "Hiragino Sans";
  background-color: ${BASIC_YELLOW};
`;
